(() => {
  'use strict';
  if (window.citydesignBackgroundVideos) {
    window.citydesignBackgroundVideos.init(document);
    return;
  }
  const instances = new Map();
  const split = (text, spaces = false) => {
    const result = []; let depth = 0; let quote = ''; let start = 0;
    for (let i = 0; i < text.length; i++) {
      const c = text[i];
      if (quote) { if (c === quote && text[i - 1] !== '\\') quote = ''; }
      else if (c === '"' || c === "'") quote = c;
      else if (c === '(') depth++;
      else if (c === ')') depth--;
      else if (!depth && (spaces ? /\s/.test(c) : c === ',')) {
        if (text.slice(start, i).trim()) result.push(text.slice(start, i).trim());
        start = i + 1;
      }
    }
    if (text.slice(start).trim()) result.push(text.slice(start).trim());
    return result;
  };
  // Resolve CSS length/percentage expressions against background free space,
  // which may be negative for cover. Browser resolves rem/vw/calc/clamp units.
  const length = (value, basis) => {
    const keywords = { left: '0%', top: '0%', center: '50%', right: '100%', bottom: '100%' };
    value = keywords[value] || value;
    const box = document.createElement('div');
    const point = document.createElement('div');
    box.style.cssText = 'position:absolute;left:0;top:-10000px;height:0;visibility:hidden;pointer-events:none;';
    point.style.cssText = 'position:absolute;top:0;width:0;height:0;';
    point.style.setProperty('display', 'block', 'important');
    box.style.setProperty('display', 'block', 'important');
    point.style.left = value;
    box.append(point); document.body.append(box);
    box.style.width = '0px';
    const zero = point.getBoundingClientRect().left - box.getBoundingClientRect().left;
    box.style.width = '100px';
    const hundred = point.getBoundingClientRect().left - box.getBoundingClientRect().left;
    box.remove();
    return zero + (hundred - zero) * basis / 100;
  };
  function mount(root) {
    if (instances.has(root)) return;
    const configNode = root.querySelector('[data-citydesign-background-video-config]');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    const video = root.querySelector('[data-citydesign-background-video]');
    const plane = video.parentElement;
    const overlay = plane.querySelector('.citydesign-background-video__overlay');
    const mobile = matchMedia('(max-width: 749px)');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    let selected = null; let timer = 0; let frame = 0; let requested = false; let disposed = false;
    function fit() {
      if (!selected || disposed) return;
      const style = getComputedStyle(root);
      const last = values => values[values.length - 1];
      const sizes = split(style.backgroundSize);
      const xs = split(style.backgroundPositionX);
      const ys = split(style.backgroundPositionY);
      const images = split(style.backgroundImage);
      const cw = root.clientWidth; const ch = root.clientHeight;
      const nw = selected.width; const nh = selected.height;
      if (!cw || !ch || !nw || !nh) return;
      const sizing = last(sizes); let w; let h;
      if (sizing === 'cover' || sizing === 'contain') {
        const ratio = (sizing === 'cover' ? Math.max : Math.min)(cw / nw, ch / nh);
        w = nw * ratio; h = nh * ratio;
      } else {
        const tokens = split(sizing, true);
        w = tokens[0] === 'auto' ? null : length(tokens[0], cw);
        h = !tokens[1] || tokens[1] === 'auto' ? null : length(tokens[1], ch);
        if (w === null && h === null) { w = nw; h = nh; }
        else if (w === null) w = h * nw / nh;
        else if (h === null) h = w * nh / nw;
      }
      const x = length(last(xs), cw - w); const y = length(last(ys), ch - h);
      Object.assign(plane.style, { left: `${x}px`, top: `${y}px`, width: `${w}px`, height: `${h}px` });
      // Remove only optional one-pixel H.264 padding, preserving source pixels.
      const padded = video.videoWidth >= nw && video.videoWidth - nw <= 1 &&
        video.videoHeight >= nh && video.videoHeight - nh <= 1;
      video.style.width = `${padded ? w * video.videoWidth / nw : w}px`;
      video.style.height = `${padded ? h * video.videoHeight / nh : h}px`;
      Object.assign(overlay.style, { left: `${-x}px`, top: `${-y}px`, width: `${cw}px`, height: `${ch}px`,
        backgroundImage: images.length > 1 ? images.slice(0, -1).join(', ') : 'none',
        backgroundSize: sizes.slice(0, images.length - 1).join(', '),
        backgroundPositionX: xs.slice(0, images.length - 1).join(', '),
        backgroundPositionY: ys.slice(0, images.length - 1).join(', ') });
    }
    function scheduleFit() { cancelAnimationFrame(frame); frame = requestAnimationFrame(fit); }
    function hide() { plane.classList.remove('is-playing'); }
    function playing() {
      if (!requested || !selected || video.readyState < 2) return;
      fit(); plane.classList.add('is-playing');
    }
    function refresh() {
      clearTimeout(timer); hide(); requested = false;
      video.pause(); video.removeAttribute('src'); video.load();
      selected = reduced.matches || connection?.saveData ? null : config[mobile.matches ? 'mobile' : 'desktop'];
      if (!selected?.url) { selected = null; return; }
      video.muted = true; video.defaultMuted = true;
      video.src = selected.url; video.load(); fit();
      timer = window.setTimeout(() => {
        requested = true;
        const promise = video.play();
        if (promise?.catch) promise.catch(() => { requested = false; hide(); });
      }, 1000);
    }
    video.addEventListener('playing', playing);
    video.addEventListener('error', hide);
    video.addEventListener('loadedmetadata', scheduleFit);
    mobile.addEventListener('change', refresh);
    reduced.addEventListener('change', refresh);
    connection?.addEventListener?.('change', refresh);
    window.addEventListener('resize', scheduleFit);
    const observer = new ResizeObserver(scheduleFit); observer.observe(root);
    instances.set(root, () => {
      disposed = true; clearTimeout(timer); cancelAnimationFrame(frame); observer.disconnect();
      video.pause(); video.removeAttribute('src'); video.load();
      mobile.removeEventListener('change', refresh); reduced.removeEventListener('change', refresh);
      connection?.removeEventListener?.('change', refresh); window.removeEventListener('resize', scheduleFit);
      video.removeEventListener('playing', playing); video.removeEventListener('error', hide);
      video.removeEventListener('loadedmetadata', scheduleFit); instances.delete(root);
    });
    refresh();
  }
  function init(scope) {
    if (scope.matches?.('[data-citydesign-background-video-root]')) mount(scope);
    scope.querySelectorAll('[data-citydesign-background-video-root]').forEach(mount);
  }
  window.citydesignBackgroundVideos = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, dispose] of instances) if (event.target.contains(root)) dispose();
  });
  init(document);
})();
